// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_REPORT_POST = "nahl\u00e1\u0161en\u00ed p\u0159\u00edsp\u011bvku";
export const PROBLEM_WAS_REPORTED_THANK_YOU = "Probl\u00e9m byl nahl\u00e1\u0161en. D\u011bkujeme.";
